import { render, staticRenderFns } from "./SwitchAttribute.vue?vue&type=template&id=812d08f0&scoped=true&"
import script from "./SwitchAttribute.vue?vue&type=script&lang=js&"
export * from "./SwitchAttribute.vue?vue&type=script&lang=js&"
import style0 from "./SwitchAttribute.vue?vue&type=style&index=0&id=812d08f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812d08f0",
  null
  
)

export default component.exports